import type { storeEn } from './en.js';

/** Storefront strings (Arabic). Keys must match en.ts. */
export const storeAr: typeof storeEn = {
  brand: 'المتجر الإلكتروني',
  links: { empty: 'لا توجد روابط بعد.' },
  nav: {
    catalog: 'المنتجات',
    cart: 'السلة',
    cartCount: 'السلة ({{count}})',
    branch: 'الفرع',
    signIn: 'تسجيل الدخول',
    account: 'حسابي',
    accountShort: 'حسابي',
    home: 'الرئيسية',
    menu: 'المنيو',
    categories: 'التصنيفات',
    openMenu: 'فتح القائمة',
    closeMenu: 'إغلاق القائمة',
    menuLabel: 'قائمة المتجر',
    quick: 'تنقل سريع',
    submenu: 'فتح قائمة {{name}}',
    allCategories: 'كل التصنيفات',
    searchStore: 'ابحث في المتجر',
    searchPlaceholder: 'عن ماذا تبحث؟',
  },
  design: {
    addToCart: 'أضف إلى السلة',
    chooseOptions: 'اختر الخيارات',
    added: 'أُضيف',
    soldOut: 'نفد',
    saleSave: 'وفّر {{amount}}',
    saleWord: 'تخفيض',
    saleEnds: 'ينتهي العرض {{when}}',
    saleYouSave: 'وفّرت {{amount}} ({{percent}}٪)',
    showMore: 'عرض المزيد ({{count}})',
    openSection: 'افتح',
    previewBadge: 'معاينة: هذا ما سيراه المتسوقون بعد النشر',
    slider: 'أبرز العروض',
    goToSlide: 'الشريحة {{n}}',
    open: 'فتح',
    seeAll: 'عرض الكل',
    tab_featured: 'موصى بها',
    tab_all: 'الكل',
    tab_bestSellers: 'الأكثر مبيعًا',
    tab_newest: 'الأحدث',
    loadMore: 'تحميل المزيد…',
    newBadge: 'جديد',
    dateBadge_roast: 'تحميص {{date}}',
    dateBadge_production: 'إنتاج {{date}}',
    roastDate: 'تاريخ التحميص: {{date}}',
    wishlistAdd: 'أضف إلى المفضلة',
    wishlistRemove: 'أزل من المفضلة',
    noBestSellers: 'الأكثر مبيعًا: يظهر هذا القسم بعد أول مبيعات (آخر 30 يومًا).',
    productCount: 'المنتجات: {{count}}',
    shopNow: 'تسوّق الآن',
    subcategories: 'التصنيفات الفرعية',
    noCategories: 'لا توجد تصنيفات بعد.',
    noMatch: 'لا شيء يطابق بحثك.',
    video: 'فيديو',
    other: 'المزيد',
    menuCategories: 'أقسام المنيو',
    addOne: 'أضف واحدًا من {{name}} إلى السلة',
    removeOne: 'احذف واحدًا من {{name}} من السلة',
    inCart: '{{count}} من {{name}} في السلة، غيّر الكمية',
    viewCart: 'اطّلع على سلّتك',
    toMinimum: 'أضف {{amount}} للوصول إلى الحد الأدنى للطلب',
    toFreeDelivery: 'أضف {{amount}} لتحصل على توصيل مجاني',
    prevSlide: 'الشريحة السابقة',
    nextSlide: 'الشريحة التالية',
    notLiveNow: 'غير ظاهر الآن (حسب الجدولة)',
    countdownNoEnd: 'العد التنازلي: حدّد تاريخ ووقت الانتهاء ليظهر.',
    countdownEnded: 'انتهى هذا العرض ولم يعد يظهر للمتسوقين.',
    timeLeft: 'الوقت المتبقي',
    unit_days: 'يوم',
    unit_hours: 'ساعة',
    unit_minutes: 'دقيقة',
    unit_seconds: 'ثانية',
    offer: 'عرض',
    stars: '{{count}} من 5 نجوم',
    reviews: 'الآراء',
    goToReview: 'الرأي {{n}}',
    faq: 'أسئلة وأجوبة',
    gallery: 'معرض الصور',
    brands: 'الماركات',
  },
  info: {
    title: 'معلومات المتجر',
    openNow: 'مفتوح الآن',
    closedNow: 'مغلق الآن',
    alwaysOpen: 'مفتوح طوال اليوم',
    closedDay: 'مغلق',
    ready: 'جاهز خلال',
    minutes: '{{count}} دقيقة',
    delivery: 'التوصيل',
    byArea: 'حسب المنطقة',
    pickup: 'الاستلام',
    available: 'متاح',
    minimum: 'الحد الأدنى للطلب',
    call: 'اتصل بنا',
    payOnReceipt: 'الدفع عند الاستلام',
  },
  days: {
    mon: 'الاثنين',
    tue: 'الثلاثاء',
    wed: 'الأربعاء',
    thu: 'الخميس',
    fri: 'الجمعة',
    sat: 'السبت',
    sun: 'الأحد',
  },
  social: {
    instagram: 'إنستقرام',
    tiktok: 'تيك توك',
    snapchat: 'سناب شات',
    x: 'إكس',
    youtube: 'يوتيوب',
    whatsapp: 'واتساب',
  },
  footer: {
    poweredBy: 'مدعوم من عربات',
    copyright: '© {{year}} {{name}}',
    backToTop: 'العودة للأعلى',
    payments: 'طرق الدفع',
  },
  account: {
    title: 'حسابي',
    hello: 'مرحبًا {{name}}',
    signIn: 'تسجيل الدخول',
    register: 'إنشاء حساب',
    createAccount: 'أنشئ حسابي',
    signOut: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    passwordHint: '8 أحرف على الأقل.',
    forgot: 'نسيت كلمة المرور؟',
    forgotTitle: 'إعادة تعيين كلمة المرور',
    forgotSent: 'إن وُجد حساب بهذا البريد فسيصلك رابط إعادة التعيين.',
    sendLink: 'إرسال الرابط',
    backToSignIn: 'العودة لتسجيل الدخول',
    resetTitle: 'اختر كلمة مرور جديدة',
    resetDone: 'تم تغيير كلمة المرور. سجّل الدخول بها.',
    resetButton: 'تغيير كلمة المرور',
    orders: 'طلباتي',
    noOrders: 'لا طلبات بعد.',
    ordersFailed: 'تعذر تحميل طلباتك.',
    items: '{{count}} صنف',
    addresses: 'عناويني',
    noAddresses: 'لا عناوين محفوظة.',
    address: 'عنوان',
    default: 'الافتراضي',
    label: 'الاسم (المنزل، العمل…)',
    makeDefault: 'اجعله عنواني الافتراضي',
    addAddress: 'إضافة عنوان',
    edit: 'تعديل',
    delete: 'حذف',
    save: 'حفظ',
    cancel: 'إلغاء',
    saved: 'تم الحفظ.',
    profile: 'بياناتي',
    changePassword: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    passwordChanged: 'تم تغيير كلمة المرور.',
    useSaved: 'عنوان محفوظ',
    newAddress: 'عنوان آخر',
    saveAddress: 'احفظ هذا العنوان في حسابي',
    signInHint: 'سجّل الدخول لاستخدام بياناتك وعناوينك.',
  },
  home: {
    title: 'المتجر الإلكتروني',
    description: 'افتح رابط المتجر الذي أرسله لك التاجر.',
  },
  closed: 'هذا المتجر لا يستقبل الطلبات حاليًا. يمكنك التصفح فقط.',
  brands: {
    title: 'العلامات التجارية',
    none: 'لا توجد ماركات بعد.',
    label: 'الماركة',
    wishlist: 'المفضلة',
    wishlistEmpty: 'لم تضف منتجات إلى المفضلة بعد. اضغط القلب على أي منتج.',
  },
  catalog: {
    category: 'التصنيف',
    all: 'الكل',
    empty: 'لا توجد منتجات متاحة على المتجر بعد.',
    unavailable: 'نفدت الكمية',
    from: 'ابتداءً من {{price}}',
    search: 'ابحث عن منتج',
    featured: 'مميّزة',
    sort: 'الترتيب',
    sort_default: 'افتراضي',
    sort_name: 'الاسم',
    sort_priceAsc: 'السعر: من الأقل',
    sort_priceDesc: 'السعر: من الأعلى',
  },
  product: {
    back: 'العودة إلى المنتجات',
    variant: 'الخيار',
    quantity: 'الكمية',
    add: 'أضف إلى السلة',
    added: 'تمت الإضافة إلى السلة',
    unavailable: 'نفدت الكمية',
    notFound: 'هذا المنتج غير متاح.',
    gallery: 'الصور',
    picture: 'الصورة {{n}}',
    share: 'مشاركة',
    linkCopied: 'تم نسخ الرابط',
    breadcrumb: 'أنت هنا',
    home: 'الرئيسية',
    products: 'المنتجات',
    sku: 'رمز المنتج: {{sku}}',
    inStock: 'متوفر',
    fewLeft: 'باقي {{count}} فقط',
    decrease: 'إنقاص الكمية',
    increase: 'زيادة الكمية',
    buyNow: 'اشترِ الآن',
    askWhatsapp: 'اسأل عبر واتساب',
    whatsappText: 'مرحبًا، عندي سؤال عن {{name}}: {{url}}',
    description: 'الوصف',
    details: 'تفاصيل المنتج',
    additional: 'معلومات إضافية',
    required: 'مطلوب',
    upTo: 'حتى {{count}}',
    choose: 'اختر {{name}}',
    note: 'اترك رسالتك هنا (اختياري)',
    metaSku: 'رمز المنتج:',
    metaCategories: 'التصنيفات:',
    metaBrand: 'الماركة:',
    metaSeparator: '،',
    related: 'قد يعجبك أيضًا',
    recent: 'شاهدتها مؤخرًا',
    zoom: 'تكبير الصورة',
    closeZoom: 'إغلاق',
    previous: 'الصورة السابقة',
    next: 'الصورة التالية',
    pictureOf: '{{n}} من {{count}}',
  },
  cart: {
    suggested: 'قد يعجبك أيضًا',
    feesAtCheckout: 'التوصيل والعروض تُحسب عند إتمام الطلب.',
    minimumProgress: 'الحد الأدنى للطلب',
    toMinimum: 'أضف {{amount}} للوصول إلى الحد الأدنى للطلب.',
    continue: 'مواصلة التسوق',
    sample: 'معاينة: منتجان للتجربة مكان السلة الفارغة.',
    title: 'سلة المشتريات',
    empty: 'سلتك فارغة.',
    browse: 'تصفح المنتجات',
    remove: 'إزالة',
    subtotal: 'المجموع الفرعي',
    checkout: 'إتمام الطلب',
    minimum: 'الحد الأدنى للطلب {{amount}}.',
    gone: 'بعض الأصناف لم تعد متاحة وتمت إزالتها.',
    increase: 'زيادة كمية {{name}}',
    decrease: 'إنقاص كمية {{name}}',
  },
  areaPrompt: {
    title: 'وين نوصّل لك؟',
    pickup: 'استلام من الفرع',
    browse: 'تصفح بدون تحديد',
    fee: 'التوصيل {{fee}}',
  },
  checkout: {
    previewOnly: 'معاينة: لا يمكن الطلب من هنا.',
    emailRequired: 'البريد الإلكتروني',
    terms: 'أوافق على شروط المتجر',
    readTerms: 'قراءة الشروط',
    termsRequired: 'وافق على الشروط لإرسال الطلب.',
    title: 'إتمام الطلب',
    contact: 'بياناتك',
    name: 'الاسم الكامل',
    phone: 'رقم الهاتف',
    email: 'البريد الإلكتروني (اختياري)',
    fulfillment: 'كيف تريد استلام طلبك؟',
    pickup: 'استلام من المتجر',
    delivery: 'توصيل',
    address: 'عنوان التوصيل',
    note: 'ملاحظة (اختياري)',
    payment: 'الدفع',
    noMethods: 'لا توجد طريقة دفع متاحة حاليًا.',
    payOnReceipt_pickup: 'الدفع عند الاستلام',
    payOnReceipt_delivery: 'الدفع عند التوصيل',
    payOnReceiptHint: 'تدفع عند استلام طلبك. يؤكد المتجر الطلب أولًا، ولا يُخصم شيء الآن.',
    branch: 'فرع الاستلام',
    area: 'منطقة التوصيل',
    searchArea: 'ابحث عن منطقتك',
    otherAreas: 'مناطق أخرى',
    noAreaMatch: 'لا توجد منطقة بهذا الاسم.',
    minutes: 'نحو {{count}} دقيقة',
    freeFrom: 'التوصيل مجاني للطلبات من {{amount}} فأكثر.',
    when: 'متى؟',
    asap: 'في أقرب وقت',
    schedule: 'اختيار موعد',
    slot: 'الموعد',
    asapHint: 'نجهّزه فوراً',
    scheduleHint: 'اختر اليوم والساعة',
    day: 'اليوم',
    today: 'اليوم',
    tomorrow: 'بكرة',
    slotChosen: 'موعد طلبك: {{when}}',
    pickTime: 'اختر الموعد',
    hour: 'الساعة',
    minute: 'الدقيقة',
    confirmTime: 'تأكيد الموعد',
    change: 'تغيير',
    closeSheet: 'إغلاق',
    noSlots: 'لا مواعيد متاحة في الأيام القادمة.',
    chooseFulfillment: 'اختر طريقة استلام طلبك.',
    whenAfterArea: 'اختر منطقتك أولًا لتظهر المواعيد.',
    closedNowLater: 'المتجر مغلق الآن. جرّب لاحقًا.',
    deliveryClosedNow: 'لا يوجد توصيل لمنطقتك الآن. يمكنك حجز موعد لاحق.',
    deliveryClosedNowLater: 'لا يوجد توصيل لمنطقتك الآن. جرّب لاحقًا.',
    notForArea: '{{name}} غير متوفر لمنطقتك.',
    removeItem: 'احذفه',
    closedNow: 'المتجر مغلق الآن. يمكنك جدولة طلبك لوقت لاحق.',
    promoCode: 'رمز العرض',
    apply: 'تطبيق',
    discount: 'الخصم',
    promoApplied: 'طُبّق «{{name}}».',
    codeIssue_unknown: 'هذا الرمز غير موجود.',
    codeIssue_inactive: 'هذا الرمز غير مفعّل.',
    codeIssue_expired: 'انتهت صلاحية هذا الرمز.',
    codeIssue_not_started: 'هذا الرمز غير صالح بعد.',
    codeIssue_minimum: 'طلبك أقل من الحد الأدنى لهذا الرمز.',
    codeIssue_quantity: 'هذا الرمز يحتاج عددًا أكبر من القطع المشمولة بالعرض.',
    codeIssue_used_up: 'استُنفد هذا الرمز.',
    codeIssue_customer_limit: 'استخدمت هذا الرمز من قبل.',
    codeIssue_no_match: 'هذا الرمز لا ينطبق على أصنافك.',
    summary: 'ملخص الطلب',
    deliveryFee: 'رسوم التوصيل',
    total: 'الإجمالي',
    submit: 'تأكيد الطلب والدفع',
    submitOnReceipt: 'تأكيد الطلب',
    required: 'مطلوب',
    reserved: 'نحجز لك الأصناف لفترة محدودة أثناء الدفع.',
  },
  pay: {
    title: 'دفع تجريبي',
    sandbox: 'بوابة تجريبية — لا يتم خصم أي مبلغ حقيقي.',
    amount: 'المبلغ',
    order: 'الطلب',
    merchant: 'التاجر',
    succeed: 'ادفع (نجاح تجريبي)',
    fail: 'محاكاة فشل الدفع',
    cancel: 'إلغاء الدفع',
    done: 'حالة هذه الدفعة: {{status}}.',
    back: 'العودة إلى الطلب',
  },
  order: {
    title: 'الطلب {{number}}',
    payNow: 'المتابعة إلى الدفع',
    payBy: 'ادفع قبل {{time}} وإلا ينتهي الطلب.',
    awaitingConfirmation: 'سيؤكد المتجر طلبك قريبًا.',
    payOnReceipt_pickup: 'تدفع عند استلام طلبك.',
    payOnReceipt_delivery: 'تدفع للمندوب عند توصيل طلبك.',
    timeline: 'مراحل الطلب',
    items: 'الأصناف',
    refresh: 'تحديث',
    pickup: 'استلام',
    delivery: 'توصيل',
    notFound: 'تعذّر العثور على هذا الطلب.',
    pickupAt: 'الاستلام من: {{branch}}',
    wanted: 'الموعد المطلوب: {{time}}',
    asap: 'في أقرب وقت',
  },
  status: {
    pending_payment: 'بانتظار الدفع',
    placed: 'تم الاستلام',
    confirmed: 'مؤكد',
    paid: 'مدفوع',
    preparing: 'قيد التجهيز',
    ready: 'جاهز للاستلام',
    out_for_delivery: 'في الطريق إليك',
    completed: 'مكتمل',
    expired: 'منتهي (لم يُدفع في الوقت)',
    payment_failed: 'فشل الدفع',
    cancelled: 'ملغي',
    needs_attention: 'قيد المراجعة من المتجر',
  },
  gateway: {
    initiated: 'قيد الانتظار',
    succeeded: 'مدفوعة',
    failed: 'فاشلة',
    cancelled: 'ملغاة',
    expired: 'منتهية',
  },
};
